import React from 'react';
import { Section } from './Section';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé toda mi temporada en una tarde. Tengo cada entrenamiento pensado y secuenciado para todos mis grupos. Nunca más el domingo de pánico.',
  name: 'Martín G.',
  role: 'Profe de Volley en Club Deportivo',
  location: '📍 Buenos Aires'
}, {
  quote: 'Las progresiones por nivel cambiaron todo. Mis jugadoras avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar.',
  name: 'Carolina R.',
  role: 'Profe de Volley en Centro Deportivo',
  location: '📍 Rosario'
}, {
  quote: 'Adapto el mismo ejercicio a 3 categorías distintas en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mixto.',
  name: 'Valeria F.',
  role: 'Profe de Volley Grupal e Individual',
  location: '📍 Córdoba'
}];
export function FeaturedTestimonials() {
  return <Section darker className="border-t border-gold-500/10" data-id="element-151">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-8" data-id="element-152">
        {testimonials.map((t, i) => <div key={i} className="bg-navy-800 p-4 md:p-8 rounded-xl md:rounded-2xl border border-navy-700 relative hover:border-gold-500/50 transition-colors duration-300" data-id="element-153">
            <Quote className="absolute top-4 right-4 md:top-6 md:right-6 w-7 h-7 md:w-10 md:h-10 text-navy-700 opacity-50" data-id="element-154" />
            <p className="text-gray-300 text-sm md:text-lg mb-3 md:mb-6 relative z-10 italic" data-id="element-155">
              "{t.quote}"
            </p>
            <div className="mt-auto pt-3 border-t border-navy-700" data-id="element-156">
              <p className="font-heading font-bold text-gold-400 text-base md:text-lg" data-id="element-157">
                {t.name}
              </p>
              <p className="text-xs md:text-sm text-gray-400" data-id="element-158">{t.role}</p>
              <p className="text-[10px] md:text-xs text-gray-500 mt-1" data-id="element-159">
                {t.location}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}